import { connect } from 'react-redux'
import MessageCard from '../../components/messages/message-card'

import at from 'lodash/at'

const mapStateToProps = (state, ownProps) => {
  const message = state.messages[ownProps.id]
  const sentBy = state.users[message.user]

  return {
    ...message,
    sentBy,
    key: ownProps.id
  }
}

export default connect(mapStateToProps)(MessageCard)



// WEBPACK FOOTER //
// ./src/containers/messages/message-card-container.js